// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2300":"d8d4260dcbfea86a","8122":"6bf4dbce460b2ed2"}[chunkId] + ".js";
};